export default {"src":"/_next/static/media/x3.a9bd2c4b.svg","height":8,"width":8,"blurWidth":0,"blurHeight":0};